exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table thead th[data-v-d662afae]{border-bottom:1px solid #eceeef;border-top:none}.fa-exclamation[data-v-d662afae]{margin-left:.25rem}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/view/TransferCompleted.vue"],"names":[],"mappings":"AACA,iCACE,gCAAiC,AACjC,eAAiB,CAClB,AACD,iCACE,kBAAqB,CACtB","file":"TransferCompleted.vue","sourcesContent":["\n.table thead th[data-v-d662afae]{\n  border-bottom: 1px solid #eceeef;\n  border-top: none;\n}\n.fa-exclamation[data-v-d662afae]{\n  margin-left: 0.25rem;\n}\n"],"sourceRoot":""}]);

// exports
